module.exports = "<div class=\"warpper\">\n  <app-page-top [hidden]=\"isHidden\" *ngIf=\"showHeader\"></app-page-top>\n  <div>\n    <p-growl [(value)]=\"msg\" [life]=\"3500\"></p-growl>\n    <router-outlet #o=\"outlet\" (activate)='onActivate($event)'></router-outlet>\n  </div>\n</div>\n<footer *ngIf=\"showHeader\">\n  <app-page-bottom></app-page-bottom>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main